interface LanguageBadgeProps {
  lang: string
  size?: 'sm' | 'md'
}

const LANG_STYLES: Record<string, { color: string; bg: string; label: string }> = {
  ru: { color: 'var(--spectrum-indigo)', bg: 'color-mix(in srgb, var(--spectrum-indigo) 14%, var(--surface))', label: 'RU' },
  pt: { color: 'var(--spectrum-teal)',   bg: 'color-mix(in srgb, var(--spectrum-teal) 14%, var(--surface))',   label: 'PT' },
  es: { color: 'var(--spectrum-orange)', bg: 'color-mix(in srgb, var(--spectrum-orange) 14%, var(--surface))', label: 'ES' },
  he: { color: 'var(--spectrum-purple)', bg: 'color-mix(in srgb, var(--spectrum-purple) 14%, var(--surface))', label: 'HE' },
}
const EN_STYLE = { color: 'var(--brand)', bg: 'var(--brand-soft)', label: 'EN' }

export function LanguageBadge({ lang, size = 'sm' }: LanguageBadgeProps) {
  const { color, bg, label } = LANG_STYLES[lang.toLowerCase()] ?? EN_STYLE
  const dotSize = size === 'md' ? 7 : 6

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        padding: '3px 9px',
        borderRadius: 'var(--radius-pill)',
        border: '1px solid color-mix(in srgb, currentColor 30%, transparent)',
        background: bg,
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: '0.04em',
        fontFamily: 'var(--font-sans)',
        color,
        flexShrink: 0,
        userSelect: 'none',
      }}
    >
      <span
        style={{
          width: dotSize,
          height: dotSize,
          borderRadius: '50%',
          background: color,
          flexShrink: 0,
          display: 'inline-block',
        }}
      />
      {label}
    </span>
  )
}
